import React, { Component } from 'react';
import { connect } from 'react-redux';
import { post } from '../Services/http';

class CookieBannerContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { value: '' };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        return post('/api/cookieconsent', "OK")            
            .then(response => {
                if (response.ok) {
                    document.getElementById('cookiebanner').classList.add('hidden');
               
                }
                return response
            })
            .then(response => response.json())
            ;
    }

    render() {
        var buttonText = document.getElementById('cookieAcceptText').innerText;
        return (
            <form className="cookiebanner__form" onSubmit={this.handleSubmit}>
                <button className="button secondary cookiebanner__btn acceptCookieBtn" type="submit">{buttonText}</button>
            </form>
        )
    }
}
export default connect()(CookieBannerContainer);